export default {
  title: '选择码批次',
};
